module.exports = __webpack_public_path__ + "img/chart-square.a8609d1b.svg";